export default __webpack_public_path__ + "static/media/vegshelf-blog-where-source-vegan-products.7f191e00.png";